import type { CityConfig } from "../city-template/types";

export const charlestonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Charleston",
  state: "South Carolina",
  stateAbbr: "SC",
  slug: "charleston",
  route: "/cities/charleston",
  title: "Emergency Passport Charleston, SC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Charleston, SC — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Charleston, Mount Pleasant, Summerville, and Lowcountry travelers. Cruise port expertise, Joint Base Charleston military families, and College of Charleston students.",
  h1: "Emergency & Expedited Passport Services in Charleston, SC",
  heroSubtitle: "Charleston cruise departing from Union Pier in two weeks? Joint Base Charleston PCS orders to Germany with a 45-day report date? College of Charleston study-abroad program in Barcelona with a tight deadline? We help Charleston residents — from South of Broad professionals to Mount Pleasant families to West Ashley creatives — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Historic%20Charleston%20South%20Carolina%20skyline%20with%20iconic%20Rainbow%20Row%20pastel%20colored%20Georgian%20townhouses%20along%20East%20Bay%20Street%2C%20cobblestone%20streets%20lined%20with%20gas%20lamps%20and%20palmetto%20trees%2C%20Charleston%20Harbor%20with%20sailboats%20and%20cruise%20ships%20in%20the%20distance%2C%20Arthur%20Ravenel%20Jr%20Bridge%20spanning%20the%20Cooper%20River%20under%20golden%20afternoon%20light%2C%20Spanish%20moss%20draped%20over%20live%20oak%20trees%20framing%20the%20waterfront%2C%20elegant%20antebellum%20architecture%20with%20wrought%20iron%20gates%20and%20flower%20boxes%2C%20sophisticated%20Southern%20coastal%20cityscape%20with%20warm%20amber%20and%20cream%20tones%2C%20professional%20travel%20photography%20composition%2C%20no%20visible%20text%20or%20people&width=1800&height=700&seq=charleston-hero-2026-v4&orientation=landscape",
  heroImageAlt: "Charleston South Carolina historic skyline with Rainbow Row and Ravenel Bridge over Charleston Harbor",
  geoPosition: "32.7765;-79.9311",
  geoPlacename: "Charleston, South Carolina",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Charleston Passport Center",
    address: "196 E Bay St, Charleston, SC 29401",
    distance: "Located in downtown Charleston at 196 E Bay Street — the Lowcountry's own passport agency",
  },
  nearbyCitiesZips: [
    { name: "Charleston (Downtown)", zips: "29401, 29403" },
    { name: "West Ashley", zips: "29407, 29414" },
    { name: "James Island", zips: "29412" },
    { name: "Johns Island", zips: "29455" },
    { name: "Daniel Island", zips: "29492" },
    { name: "Mount Pleasant", zips: "29464, 29466" },
    { name: "Summerville", zips: "29483, 29485, 29486" },
    { name: "North Charleston", zips: "29405, 29406, 29418, 29420" },
    { name: "Goose Creek", zips: "29445" },
    { name: "Hanahan", zips: "29410" },
    { name: "Ladson", zips: "29456" },
    { name: "Moncks Corner", zips: "29461" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the Charleston Passport Agency — as fast as 24 hours for Lowcountry travelers with immediate departures from CHS or Union Pier." },
    { icon: "ri-anchor-line", title: "Cruise Port Expertise", desc: "Union Pier Terminal sends thousands of passengers to the Bahamas and Caribbean weekly. We know cruise documentation requirements inside and out." },
    { icon: "ri-shield-line", title: "Military Family Specialist", desc: "Joint Base Charleston PCS orders, dependent passports, deployment readiness — we process on military timelines, not government ones." },
    { icon: "ri-graduation-cap-line", title: "College of Charleston + Student Travel", desc: "Study-abroad deadlines, spring break passports, academic conference travel — we help CofC students and faculty meet their deadlines." },
  ],
  internalLinks: [
    { name: "Expedited passport in Mount Pleasant, SC", route: "/cities/mount-pleasant" },
    { name: "Fast passport services in Columbia, SC", route: "/cities/columbia-sc" },
    { name: "Quick passport services in Myrtle Beach, SC", route: "/cities/myrtle-beach" },
    { name: "South Carolina passport services overview", route: "/states/south-carolina" },
  ],
  fpcOfficeAddress: "196 E Bay St, Charleston, SC 29401",
  fpcOfficeNote: "Fast Passport Center serves Charleston via secure registered courier with direct access to the Charleston Passport Agency at 196 E Bay St. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Charleston residents can ship from any UPS Store, FedEx Office, or post office location across the Lowcountry.",
  fpcOfficeDistance: "Serving Charleston, Mount Pleasant, North Charleston, Summerville, Goose Creek, and all Charleston County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Charleston and the South Carolina Lowcountry. From the historic French Quarter and South of Broad to West Ashley and James Island, from Daniel Island to Mount Pleasant — we serve all of Charleston County, Berkeley County, and Dorchester County. Our courier service eliminates the need to compete for scarce agency appointments at the downtown Charleston Passport Agency.",
  nearbyCitiesIntro: "We serve Charleston and all Lowcountry communities including Mount Pleasant, North Charleston, Summerville, Goose Creek, Hanahan, Ladson, Moncks Corner, James Island, Johns Island, and Daniel Island. We also serve Joint Base Charleston military families and College of Charleston students.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Charleston as simple as possible — with the Southern hospitality and reliability Lowcountry travelers expect. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Charleston travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Charleston travelers encounter unique passport issues — from cruise documentation confusion to military PCS timeline compression to international tourist passport emergencies. Here are the most common passport mistakes we see from the Lowcountry.",
  testimonialsIntro: "Charleston travelers — from South of Broad families to Mount Pleasant professionals to Joint Base Charleston military families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Charleston, SC? Here are the most common ones we hear from Lowcountry travelers.",
  statePageRoute: "/states/south-carolina",
  statePageName: "South Carolina",
  servicesIntro: "Whether you need a renewal before a Charleston cruise departure, an emergency passport for a military PCS move, or a first-time passport for a Lowcountry family vacation — Fast Passport Center handles it with reserved courier submission availability and direct Charleston Passport Agency access. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.scdmvonline.com/",
  dmvLabel: "South Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct Charleston Passport Agency access", "Predictable turnaround", "Ideal for upcoming cruises and trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Charleston agency serves entire Lowcountry — appointments scarce", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Charleston cruise departing in two days? Military PCS orders with immediate report date? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Lowcountry travelers.",
      bullets: ["As fast as 24 hours", "Direct Charleston Passport Agency access", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Charleston residents renew fast — no agency visit required for most renewals. Perfect for Lowcountry professionals, Mount Pleasant families, and retirees planning international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Charleston residents through every step — from downtown to West Ashley to Summerville — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your cruise or international flight from CHS is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Lowcountry family cruise or international vacation stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Charleston newlyweds after destination weddings.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Charleston business travelers, military personnel, and consultants who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. Charleston's humid subtropical climate claims more water-damaged passports than you'd expect — we guide you through the replacement process.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Popular with Charleston cruise passengers who want a compact backup ID.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Charleston SC", description: "Urgent passport processing for Charleston South Carolina travelers with immediate departure needs from CHS Airport or Union Pier cruise terminal." },
    { name: "Expedited Passport Renewal Charleston SC", description: "Fast passport renewal for Charleston South Carolina residents with a previously-issued passport." },
    { name: "First-Time Passport Charleston SC", description: "New passport application services for Charleston South Carolina residents applying for their first passport." },
    { name: "Child Passport Charleston SC", description: "Minor passport services for Charleston South Carolina families with children under 16." },
    { name: "Name Change Passport Charleston SC", description: "Passport name correction after marriage, divorce, or legal name changes for Charleston residents." },
    { name: "Second Passport Charleston SC", description: "Second passport services for Charleston business travelers and military personnel who travel internationally." },
  ],
  testimonials: [
    {
      name: "Margaret S.",
      location: "South of Broad, Charleston",
      rating: 5,
      text: "We booked a last-minute cruise from Union Pier to the Bahamas for our anniversary. Three days before departure, I discovered my passport had expired. Fast Passport Center got my renewal processed in 48 hours. We made the ship with time to spare.",
      service: "Passport Renewal",
    },
    {
      name: "Lt. Col. David R.",
      location: "Joint Base Charleston",
      rating: 5,
      text: "Received PCS orders to Germany with a 45-day report date. Three dependents needed passport renewals. Fast Passport Center handled all three simultaneously and got them back in 4 days. The base personnel office couldn't believe the turnaround.",
      service: "Military Family Passports",
    },
    {
      name: "Sarah K.",
      location: "Mount Pleasant, SC",
      rating: 5,
      text: "My daughter's study abroad application at the College of Charleston was accepted to a program in Barcelona with a two-week deadline for passport submission. We had never applied for a passport for her. Fast Passport Center guided us through the DS-11 process and got us her first passport in 5 days.",
      service: "New Passport",
    },
    {
      name: "James W.",
      location: "James Island, SC",
      rating: 5,
      text: "Lost my passport somewhere between a King Street restaurant and the Battery. Realized it was gone two days before a business trip to London. Fast Passport Center handled the DS-64 and got me a replacement passport in less than 48 hours. Made the flight.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "charleston-1",
      name: "Charleston Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "557 E Bay St",
      city: "Charleston",
      state: "SC",
      zip: "29403",
      phone: "(843) 727-0590",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Charleston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main downtown post office. Passport acceptance by appointment only. Convenient for French Quarter and South of Broad residents.",
      icon: "ri-mail-line",
    },
    {
      id: "charleston-2",
      name: "Charleston County Public Library — Main Branch",
      type: "Community Passport Acceptance",
      address: "68 Calhoun St",
      city: "Charleston",
      state: "SC",
      zip: "29401",
      phone: "(843) 805-6801",
      hours: "Mon–Thu: 9:00 AM – 8:00 PM, Fri–Sat: 9:00 AM – 6:00 PM",
      distance: "0.5 miles from Marion Square",
      website: "https://www.ccpl.org/",
      websiteLabel: "Charleston County Public Library",
      notes: "Central location with evening hours. Limited passport acceptance slots — call ahead to confirm availability. Photo services not available on-site.",
      icon: "ri-building-line",
    },
    {
      id: "charleston-3",
      name: "West Ashley Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "78 Sycamore Ave",
      city: "Charleston",
      state: "SC",
      zip: "29407",
      phone: "(843) 556-4683",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "6 miles from downtown Charleston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for West Ashley and Avondale area residents. Appointments recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "charleston-4",
      name: "Mount Pleasant Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1050 Johnnie Dodds Blvd",
      city: "Mount Pleasant",
      state: "SC",
      zip: "29464",
      phone: "(843) 884-6484",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "7 miles from downtown Charleston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest acceptance facility east of the Cooper River. Serves Mount Pleasant and East Cooper communities. Appointments strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "charleston-5",
      name: "North Charleston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6401 Rivers Ave",
      city: "North Charleston",
      state: "SC",
      zip: "29406",
      phone: "(843) 554-4635",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles from downtown Charleston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves North Charleston and Hanahan area. More appointment availability than downtown locations. Convenient for Joint Base Charleston personnel.",
      icon: "ri-mail-line",
    },
    {
      id: "charleston-6",
      name: "Summerville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 N Gum St",
      city: "Summerville",
      state: "SC",
      zip: "29483",
      phone: "(843) 871-1312",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles from downtown Charleston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main Summerville facility. Appointments recommended — growing area with high demand.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — visit Charleston Passport Agency on East Bay Street", fpc: "Most Lowcountry travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Charleston-Specific Guidance", agency: "Generic — no cruise port, military base, or Lowcountry expertise", fpc: "Full Charleston cruise/military/CofC/Lowcountry knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming the Charleston Agency Takes Walk-Ins",
      description: "The Charleston Passport Agency at 196 E Bay Street requires appointments even for emergencies. Many Charleston residents show up without an appointment and are turned away. Our courier channel bypasses this entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Cruise Documentation Confusion",
      description: "Many Charleston cruise passengers do not realize that closed-loop cruises to the Bahamas still require a passport for emergency disembarkation. Without one, you may not be allowed off the ship in certain ports.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Charleston pharmacies and photo centers produce photos that fail State Department standards. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Lowcountry families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Military PCS Timeline Compression",
      description: "Joint Base Charleston personnel receiving PCS orders often have 30–60 day windows. Dependent passports must be current. Standard processing (8–11 weeks) will miss the report date. Start expedited immediately upon receiving orders.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or a King Street coffee shop." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your cruise, military, or travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Charleston clients ship from home or a nearby UPS Store — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved Charleston Passport Agency availability — so you do not have to compete for scarce public appointments or wait at the East Bay Street agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Charleston?", a: "We offer Charleston-area clients expedited processing as fast as 24 hours through our registered courier service to the Charleston Passport Agency. Standard expedited service typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Charleston office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (a Charleston post office or county library), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Charleston address." },
    { q: "Where can I get a passport acceptance in Charleston?", a: "Charleston has acceptance facilities at the Main Post Office (557 E Bay St), Charleston County Public Library (68 Calhoun St), West Ashley Post Office, Mount Pleasant Post Office, North Charleston Post Office, and Summerville Post Office. We maintain an updated list with hours, photo availability, and appointment options." },
    { q: "Does the Charleston Passport Agency handle walk-ins?", a: "The Charleston Passport Agency (located at 196 E Bay Street) requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel without agency restrictions." },
    { q: "What is the best price for expedited passport service in Charleston?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "I'm stationed at Joint Base Charleston and got PCS orders overseas — how fast can you process my dependents' passports?", a: "We specialize in military family passport processing to Joint Base Charleston. With PCS orders in hand, we can expedite dependent passports in 24–48 hours through our emergency courier service. Our team understands military timelines and documentation requirements." },
    { q: "Do I need a passport for a cruise leaving from Charleston?", a: "While closed-loop cruises from Union Pier Terminal technically only require a birth certificate and government ID, you need a passport for emergency disembarkation in foreign ports or if you need to fly home from a port of call. We strongly recommend all cruise passengers carry a valid passport." },
    { q: "I'm a College of Charleston student — can you help with study abroad passport deadlines?", a: "Absolutely. We help CofC students every semester with study abroad passport applications and renewals. Our team knows the tight deadlines study abroad programs impose and can process your passport fast enough to meet application requirements." },
    { q: "How do I check my Charleston passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Charleston to final return shipping typically matches your chosen speed tier." },
    { q: "Can tourists visiting Charleston get passport help here?", a: "Yes. If you are an American citizen visiting Charleston and discover a passport issue, Fast Passport Center can help. We can process your passport and ship it to your hotel or temporary address in the Charleston area." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Charleston Residents",
    intro: "Charleston's unique combination of a major cruise port, active military base, thriving tourism economy, and growing international airport creates distinct passport timing challenges. Here's what Lowcountry travelers need to know.",
    cards: [
      {
        icon: "ri-anchor-line",
        title: "Union Pier Cruise Terminal",
        subtitle: "Charleston's gateway to the Bahamas, Caribbean, and beyond",
        description: "The Port of Charleston's cruise terminal at Union Pier sends thousands of passengers to the Bahamas, Caribbean, and beyond each year. Carnival Cruise Line operates regularly from Charleston, with itineraries to Nassau, Half Moon Cay, and Grand Turk. Cruise bookings often happen months in advance, but passengers routinely discover expired passports just days before departure. The terminal's proximity to downtown means many Charleston residents treat cruising as a last-minute getaway option — and last-minute bookings mean last-minute passport urgencies.",
        tip: "Cruise lines strongly recommend passports valid 6 months beyond your return date, even for closed-loop cruises. If you need emergency medical evacuation from a foreign port, you cannot fly back to the U.S. without a valid passport. Book your passport renewal the same day you book your cruise.",
      },
      {
        icon: "ri-shield-line",
        title: "Joint Base Charleston — Military PCS & Deployment",
        subtitle: "Air Force and Naval operations, 20,000+ personnel",
        description: "Joint Base Charleston combines Charleston Air Force Base and Naval Weapons Station Charleston, supporting over 20,000 active-duty personnel, reservists, and civilian employees. PCS orders to overseas assignments (Germany, UK, Japan, Korea, Italy) typically come with 30–60 day report dates. Dependent passports must be current — and standard processing (8–11 weeks) will miss the window. The base's C-17 airlift operations mean personnel deploy on short notice to destinations across Europe, the Middle East, and Asia. When a service member discovers during out-processing that their family's passports need renewal, they need a solution that works on a military timeline.",
        tip: "Military families should check all dependent passport expiration dates immediately upon receiving PCS orders. Even passports with 6+ months remaining may need renewal for certain OCONUS assignments. Fast Passport Center can process multiple family passports simultaneously in 2–9 business days.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "CHS — Charleston International Airport",
        subtitle: "Growing international service, Lowcountry's aviation gateway",
        description: "Charleston International Airport (CHS) serves over 5 million passengers annually with direct flights to major U.S. hubs and growing international routes including London on British Airways and seasonal Caribbean destinations. Boeing's 787 Dreamliner assembly facility adjacent to CHS drives significant international business travel. The airport's expansion continues adding routes, making spontaneous international getaways increasingly common among Charleston residents.",
        tip: "British Airways' CHS-London route requires 6-month passport validity beyond return date. Many Charleston travelers book this flight months ahead, then discover during online check-in that their passport expires mid-trip. Always verify validity at time of booking.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "College of Charleston & Academic Travel",
        subtitle: "Study abroad, research conferences, spring break",
        description: "College of Charleston sends hundreds of students abroad annually through semester exchange, summer programs, and faculty-led trips. The acceptance-to-departure pipeline is often 6–10 weeks — tight for standard passport processing. Additionally, MUSC (Medical University of South Carolina) physicians and researchers attend international conferences in Geneva, Barcelona, and Tokyo with 2–4 week notice. The Citadel's international programs and ROTC cadets heading to training abroad add another layer of demand for expedited service.",
        tip: "CofC study abroad students should apply for passports immediately upon program acceptance — do not wait until orientation. The 6–10 week window between acceptance and departure is tight for standard processing but comfortable for expedited courier service.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Charleston's Passport Agency — A Lowcountry Advantage",
      description: "Charleston is one of the few mid-sized American cities with its own regional passport agency, located at 196 E Bay Street. While the agency primarily serves life-or-death emergencies by appointment, its presence in Charleston means our registered couriers can achieve same-day document submission — a significant advantage over cities without local agencies. For Lowcountry travelers, this translates to the fastest possible turnaround of any South Carolina city.",
    },
  },
  destinations: {
    title: "Where Charleston Travelers Go — And Why Passports Get Urgent",
    intro: "From cruises to the Caribbean to military deployments in Europe, Charleston's international travel patterns reflect its coastal location, military presence, and historic global connections.",
    stats: [
      { stat: "35%", label: "of Charleston expedited requests are cruise-related with under 3 weeks notice" },
      { stat: "2–3 Weeks", label: "average lead time Charleston travelers have from trip booking to international departure" },
      { stat: "Mar–Jun", label: "peak season when spring break, cruise season, PCS season, and study abroad deadlines collide" },
      { stat: "30 Hours", label: "shortest turnaround we have accommodated for a Charleston cruise passenger" },
    ],
    destinations: [
      { name: "Bahamas & Caribbean", context: "Union Pier cruise terminal departures, Carnival Cruise Line itineraries, spring break getaways, destination weddings at Sandals resorts", urgency: "Cruise bookings peak January through March for spring departures", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "British Airways CHS-London nonstop, heritage travel (strong British and Scottish ancestry in Lowcountry), business connections", urgency: "6-month passport validity required; business trips booked 2–3 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "Joint Base Charleston PCS assignments to Ramstein and Stuttgart, Boeing supplier relationships, Mercedes-Benz Vans plant in North Charleston connections", urgency: "Military PCS orders provide 30–45 day windows for dependent passport processing", icon: "ri-map-pin-2-line" },
      { name: "Italy & France", context: "College of Charleston study abroad in Florence and Paris, destination weddings in Tuscany, culinary tourism, MUSC medical conferences", urgency: "Study abroad deadlines fixed with 6–10 week application windows", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "Joint Base Charleston deployments, Boeing 787 supplier visits, Asian manufacturing partnerships for Lowcountry businesses", urgency: "Military deployments require all dependent passports current before departure", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Central America", context: "CHS seasonal flights to Cancun, spring break, medical mission trips from MUSC, destination weddings in Riviera Maya", urgency: "Spring break bookings finalized 3–4 weeks before departure", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other South Carolina Service Areas",
    crossLinksDesc: "We serve travelers across the Palmetto State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Columbia", route: "/cities/columbia-sc" },
      { name: "Myrtle Beach", route: "/cities/myrtle-beach" },
      { name: "Greenville", route: "/cities/greenville-sc" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — King Street", address: "351 King St, Charleston, SC 29401", hours: "Mon–Sun: 7AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walgreens — Calhoun Street", address: "372 King St, Charleston, SC 29401", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "FedEx Office — Downtown", address: "550 King St, Charleston, SC 29403", hours: "Mon–Fri: 7AM–9PM, Sat: 9AM–6PM", website: "https://local.fedex.com/en-us/sc/charleston" },
    { name: "UPS Store — West Ashley", address: "946 Orleans Rd, Charleston, SC 29407", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–4PM", website: "https://locations.theupsstore.com/sc/charleston" },
    { name: "Walmart — North Charleston", address: "7400 Rivers Ave, North Charleston, SC 29406", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "CVS Pharmacy — Mount Pleasant", address: "654 Coleman Blvd, Mount Pleasant, SC 29464", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walgreens — James Island", address: "612 Folly Rd, Charleston, SC 29412", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "FedEx Office — Mount Pleasant", address: "1220 Ben Sawyer Blvd, Mount Pleasant, SC 29464", hours: "Mon–Fri: 7AM–9PM, Sat: 9AM–6PM", website: "https://local.fedex.com/en-us/sc/mount-pleasant" },
  ],
  dmvLocations: [
    {
      name: "SCDMV — Charleston (Leeds Avenue)",
      address: "3790 Leeds Ave, North Charleston, SC 29405",
      hours: "Mon–Fri: 8:30AM–5PM",
      note: "Full-service DMV with REAL ID processing. About 8 miles from downtown. Appointments recommended.",
      featured: true,
    },
    {
      name: "SCDMV — Mount Pleasant",
      address: "1189 Iron Bridge Dr, Mount Pleasant, SC 29466",
      hours: "Mon–Fri: 8:30AM–5PM",
      note: "East Cooper area DMV. Often less crowded than the Leeds Avenue location. About 10 miles from downtown.",
      featured: true,
    },
    {
      name: "SCDMV — Summerville",
      address: "120 S Main St, Summerville, SC 29483",
      hours: "Mon–Fri: 8:30AM–5PM",
      note: "Dorchester County DMV. Good option for Summerville and Ladson area residents. About 25 miles from downtown.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "CHS",
      name: "Charleston International Airport",
      distance: "12 miles from downtown Charleston",
      address: "5500 International Blvd, North Charleston, SC 29418",
      note: "Charleston's primary airport with direct flights to major U.S. hubs and growing international routes including London on British Airways and seasonal Caribbean destinations. The gateway for Lowcountry international travel.",
      flightUrl: "https://www.iflychs.com/",
      flightLabel: "Charleston Airport",
      featured: true,
    },
    {
      code: "CAE",
      name: "Columbia Metropolitan Airport",
      distance: "110 miles from Charleston",
      address: "3250 Airport Blvd, West Columbia, SC 29170",
      note: "Alternative airport option for Midlands residents. About 1.5 hours drive via I-26.",
      flightUrl: "https://www.flycae.com/",
      flightLabel: "Columbia Airport",
      featured: false,
    },
    {
      code: "SAV",
      name: "Savannah/Hilton Head International Airport",
      distance: "110 miles from Charleston",
      address: "400 Airways Ave, Savannah, GA 31408",
      note: "Southern alternative for Lowcountry travelers. About 2 hours drive via US-17. Direct flights to major U.S. hubs.",
      flightUrl: "https://savannahairport.com/",
      flightLabel: "Savannah Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the South Carolina Department of Health and Environmental Control Vital Records office. Online, mail, or in-person options available for Charleston County.",
      url: "https://scdhec.gov/vital-records",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through SC DHEC Vital Records. Required for estate and legal matters in Charleston County.",
      url: "https://scdhec.gov/vital-records",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Charleston County Probate Court. Certified copies for name changes and passport applications.",
      url: "https://www.charlestoncounty.org/departments/probate/marriage-license.php",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Charleston County Clerk of Court. Required for name change passport corrections.",
      url: "https://www.charlestoncounty.org/departments/clerk-of-court/",
    },
  ],
};